module.exports = __webpack_public_path__ + "img/RECUADRO_Learning.9f2f645a.png";